module.exports = __webpack_public_path__ + "resources/img/img_seculetter_email_cloud_security_m.7c59bd5df23ad3ee7df9645146629e51.png";